<template>
  <div class="container">
    <div>
      <img :src="leadIcon" alt="open" />
      <p>
        La integración de leads en el módulo de secuencias se realizará mediante APIs. Todos los
        leads que ingresen al sistema se gestionarán a través de estas integraciones. Asegúrate de
        revisar la <a :href="url" target="_blank">documentación de APIs</a> para configurar correctamente esta funcionalidad.
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import leadIcon from "@/app/flows/sequences/assets/lead-icon.svg?url";
// Update according to the environment 
const url = `https://api.${import.meta.env.VITE_HOSTNAME}/docs`;
</script>

<style scoped lang="sass">
.container
  width: 100%
  text-align: center
  margin-bottom: 25px
  display: flex
  height: calc(100vh - 500px)
  align-items: center

  p
    color: $text-secondary
    margin: 0
    font-size: 16px
</style>
